import { Component, EventEmitter, OnInit, Output, ViewChild, Input } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../../environments/environment';
import { IUser } from '../../../../../core/models/user.model';
import { SocialAuthService, SocialUser } from 'angularx-social-login';
import { FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';
import { Subscription, interval } from 'rxjs';
/**
* Reusable login form component
*/
@Component({
  selector: 'app-login-form-mobile',
  templateUrl: './mobile-login-form.component.html',
  styleUrls: ['./login-form.component.css']
})
export class MobileLoginFormComponent implements OnInit {

  private _url = `${environment.backendRoot}/webresources/frontend/entity.users/login`;
  @Input() loginVisible;
  @Output() modalClosed: EventEmitter<any> = new EventEmitter();

  user = {
    email: null,
    passwd: null
  };
  forgotPassword = false;
  signedUpNow: number;
  private fbuser: SocialUser;
  subscription: Subscription;
  private loggedIn: boolean;
  confirmedNewPassword;
  userSignup = {email: null, name: null, surname: null, passwd: null, confirmedPassword: null};
  @Output() sendResult: EventEmitter<any> = new EventEmitter();
  @Output() sendSignup: EventEmitter<any> = new EventEmitter();
  @Output() socialLogin: EventEmitter<any> = new EventEmitter();
  @Output() sendNewPassword: EventEmitter<any> = new EventEmitter();
  constructor(protected http: HttpClient, private authService: SocialAuthService) {
  }

  ngOnInit() {
    this.signedUpNow = 1;
  }

  onInternalSubmit() {
    // localStorage.setItem('user', JSON.stringify(this.user));
    this.sendResult.emit([this.user]);
  }

  signUp() {
    if (this.isPasswordMatch()) {
      delete this.userSignup.confirmedPassword;
      this.sendSignup.emit([this.userSignup]);
    } else {
      alert('Passwords do not Match!!');
    }
  }

  dismiss() {
    this.modalClosed.emit([true]);
  }

  isPasswordMatch() {
    if (this.userSignup.passwd === this.userSignup.confirmedPassword) {
      return true;
    }
    return false;
  }
  onForgotPassword() {
    // localStorage.setItem('user', JSON.stringify(this.user));
    if (this.user.passwd === this.confirmedNewPassword) {
      this.sendNewPassword.emit([this.user]);
      this.forgotPassword = false;
    } else {
      alert('Passwords do not Match!!');
    }
  }
  isLogin() {
    return this.loginVisible;
  }

  showSignup() {
    this.loginVisible = false;
  }

  showSignin() {
    this.loginVisible = true;
  }

  socialSignup(social) {
    if (social === 'loginFacebook' || social === 'signupFacebook') {
      this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
    } else if (social === 'loginGoogle' || social === 'signupGoogle') {
      this.signedUpNow = 1;
      this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
    }


    this.authService.authState.subscribe((user) => {
      this.fbuser = user;
      this.loggedIn = (user != null && user !== undefined);
      if (this.loggedIn && social === 'signupFacebook') {
        this.userSignup = {
          email: this.fbuser.email,
          name: this.fbuser.firstName,
          surname: this.fbuser.lastName,
          passwd: this.fbuser.id,
          confirmedPassword: this.fbuser.id};
          this.signUp();
      } else if (this.loggedIn && social === 'loginFacebook') {
        this.user = {
          email: this.fbuser.email,
          passwd: this.fbuser.id,
          };
          this.onInternalSubmit();
      } else if (this.loggedIn && social === 'signupGoogle') {
        this.userSignup = {
          email: this.fbuser.email,
          name: this.fbuser.firstName,
          surname: this.fbuser.lastName,
          passwd: this.fbuser.id,
          confirmedPassword: this.fbuser.id};
          if (this.signedUpNow >= 2) { return; }
          this.signUp();
          this.signedUpNow = this.signedUpNow + 1;
      } else if (this.loggedIn && social === 'loginGoogle') {
        this.user = {
          email: this.fbuser.email,
          passwd: this.fbuser.id,
          };
          this.onInternalSubmit();
      }
    });
    this.closeLoginWindow();
  }

  socialSignin(social) {
    if (social === 'loginFacebook') {
      this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
      this.authService.authState.subscribe((user) => {
        this.loggedIn = (user != null && user !== undefined);
        this.fbuser = user;
        this.loggedIn = (user != null);
        this.user = {
          email: this.fbuser.email,
          passwd: this.fbuser.id,
          };

          this.onInternalSubmit();
      });
    } else if (social === 'loginGoogle') {
      this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
      const source = interval(2000);
      this.subscription = source.subscribe(val => {
        this.authService.authState.subscribe((user) => {
          this.loggedIn = (user != null && user !== undefined);
            if (this.loggedIn) {
              this.fbuser = user;
              this.loggedIn = (user != null);
              this.user = {
                email: this.fbuser.email,
                passwd: this.fbuser.id,
                };
              this.onInternalSubmit();
              this.subscription.unsubscribe();
            }
        // console.log(user);
        });
      });
    }
  }

  closeLoginWindow() {
    this.modalClosed.emit([true]);
  }
}
